import { useEffect, useMemo, useState } from 'react';

type Props<T> = {
    items: T[];
    itemsPerPage?: number;
};

export const usePagination = <T>({ items = [], itemsPerPage }: Props<T>) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [currentItemsPerPage, setCurrentItemsPerPage] = useState(
        itemsPerPage || 10
    );

    const currentItems = useMemo(() => {
        return items
            ? items.slice(
                  currentPage * currentItemsPerPage,
                  currentPage * currentItemsPerPage + currentItemsPerPage
              )
            : [];
    }, [currentPage, items, currentItemsPerPage]);

    useEffect(() => {
        if (currentPage !== 0) {
            setCurrentPage(0);
        }
    }, [items]);

    return {
        currentItems,
        setNextPage: setCurrentPage,
        page: currentPage,
        setItemsPerPage: setCurrentItemsPerPage,
        itemsPerPage: currentItemsPerPage,
        countTotal: items.length,
    };
};
